import { FC, memo } from 'react';
// Types
import QuizTypes from 'types/QuizTypes';
// Models
import IQuiz from 'models/Quiz';
// Redux
import { useAppDispatch, useAppSelector } from 'hooks/useStore';
// Actions
import { setQuestionReady, setQuestionStart } from 'store/player/playerSlice';
// Models
import IQuestion from 'models/Question';
// Selectors
import { selectQuiz, selectQuestion } from 'store/quiz/quizSelectors';
// Components
import Video from 'components/Video';

const QuestionMedia:FC = () => {
  // Dispatch
  const dispatch = useAppDispatch();
  // State
  const quiz:IQuiz = useAppSelector(selectQuiz);
  const question:IQuestion = useAppSelector(selectQuestion);

  const handleCallback = () => {
    dispatch(setQuestionReady(true));
    if ( [QuizTypes.Scoring, QuizTypes.Prediction].includes(quiz.type) ) dispatch(setQuestionStart(true));
  };

  return question.video ? (
    <Video
      videoClasses="w-full aspect-video"
      videoUrl={question.video}
      onEndedCallback={handleCallback}
      isQuestionVideo={true}
    />
  ) : (
    <div className="w-full" style={{ height: 236 }}>
      <img
        className="block max-w-full h-full mx-auto object-cover"
        src={question.image || quiz.mastheadImage}
        alt=""
        onLoad={handleCallback}
      />
    </div>
  );
}

export default memo(QuestionMedia);
